/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.ReferralStatus = class ReferralStatus {
  constructor(el) {
    this.el = el;
    this._bindEvents();
  }

  _bindEvents() {
    return this.el.find("ul.statuses a").on("click", event => {
      event.preventDefault();
      const status = $(event.currentTarget).attr("href").replace("#", "");
      this.el.removeClass("successful unsuccessful pending");
      return this.el.addClass(status);
    });
  }
};
